import {
    FieldSelectComponent as SourceFieldSelectComponent,
} from 'SourceComponent/FieldSelect/FieldSelect.component';
import React from 'react';
import './FieldSelect.override.style';

export class FieldSelectComponent extends SourceFieldSelectComponent {
    renderNativeSelect() {
        const {
            setRef,
            attr,
            events,
            isDisabled,
            options,
            handleSelectListOptionClick,
            isSelectedOptionAvailable,
        } = this.props;

        if (attr?.defaultValue) {
            const data = options.filter((value) => (
                value?.value == attr?.defaultValue
            ));

            if (data?.length > 0) {
                handleSelectListOptionClick(data[0]);
            }
        }

        return (
            <select
                className={(!isSelectedOptionAvailable ? "FieldSelect-Select_isDisabled" : "") + "FieldSelect-Select"}
                ref={(elem) => setRef(elem)}
                disabled={isDisabled}
                {...attr}
                {...events}
                onChange={handleSelectListOptionClick}
            >
                {options.map(this.renderNativeOption.bind(this))}
            </select>
        );
    }
}

export default FieldSelectComponent;
